<template>
	<div class="lnk-dlgform-panel">
		<slot></slot>
		<template v-if="$slots['dialog-form']">
			<el-dialog append-to-body
					   :show-close="false"
					   class="lnk-dlgform-panel__dialog"
					   :title="titleStr"
					   :visible.sync="isShow"
					   :close-on-click-modal="false"
					   :close-on-press-escape="false">
				<el-form ref="form"
						 :model="option.data"
						 :label-width="labelWidth"
						 v-bind="option.elFormProps">
					<slot name="dialog-form"></slot>
				</el-form>
				<template slot="footer">
					<link-button type="line"
								 :disabled="option.isSaving"
								 @click="isShow=false">取消</link-button>
					<link-button @click="submit">确定</link-button>
				</template>
			</el-dialog>
		</template>
	</div>
</template>

<script>
	export default {
		name: "lnk-dlgform-panel",
		props: {
			/*FormOption*/
			option: {type: Object, default: () => ({})},
			/*标题*/
			title: {
				type: String,
				default: ''
			}
		},
		data(){
        	return{
        		isShow: false, //是否显示弹框
				autoTables: [], //link-auto-table实例
				staticTables: [] //link-static-table实例
			}
		},
		computed: {
			/*link-auto-table实例*/
			autoTable() {
				return this.autoTables[this.autoTables.length - 1] || null;
			},
        	/*link-static-table实例*/
        	staticTable(){
        		return this.staticTables[this.staticTables.length-1] || null ;
			},
			/*el-form的label-width*/
			labelWidth() {
				const option = this.option || {};
				return (option.elFormProps || {}).labelWidth || '120px';
			},
			/*弹框的标题*/
			titleStr() {
				return this.title || this.option.title || (this.option.isInsert ? '新建' : '修改')
			}
		},
		watch: {
			isShow(value) {
				if (value) {
					this.$nextTick(() => {
						if (this.$refs.form && this.option instanceof FormOption) {
							this.option.bindElForm(this.$refs.form);
							this.$nextTick(() => this.option.clearValidate())
						}
					});
				}
			}
		},
		methods:{
        	/**
        	 * @method：init
        	 * @createdBy:黄健
        	 * @date:2020/1/19
        	 * @params：
        	 * @description：初始化
        	 */
        	init(){
        		this.autoTables = this.$getChildComponent('link-auto-table',false);
        		this.staticTables = this.$getChildComponent('link-static-table',false);
        		this.option.openInsert = this.openInsert.bind(this);
        		this.option.openEdit = this.openEdit.bind(this);
        		this.option.openCopy = this.openCopy.bind(this);
        		this.option.deleteRow = this.deleteRow.bind(this);
			},
			/**
			 * @method：openInsert
			 * @createdBy:黄健
			 * @date:2020/1/20
			 * @description：打开新建弹框
			 */
			async openInsert() {
				await this.option.doInsert();
				this.isShow = true;
			},
			/**
			 * @method：openEdit
			 * @createdBy:黄健
			 * @date:2020/1/20
			 * @params row：数据行
			 * @params index：数据行索引
			 * @description：打开编辑弹框
			 */
			async openEdit(row = {}, index) {
				this.option.data = row;
				this.option._index = index;
				await this.option.doUpdate();
				this.isShow = true;
			},
			/**
			 * @method：openCopy
			 * @createdBy:黄健
			 * @date:2020/1/20
			 * @params row：数据行
			 * @params index：数据行索引
			 * @description：打开编辑弹框
			 */
			async openCopy(row = {}, index) {
				this.option.data = row;
				this.option._index = index;
				await this.option.doCopy();
				this.isShow = true;
			},

			/**
			 * @method：submit
			 * @createdBy:黄健
			 * @date:2020/1/20
			 * @params：
			 * @description：提交保存
			 */
			async submit() {
				if (!this.isShow) return;
				if (this.option.isSaving) return;
				const {isInsert, data: rawData} = this.option;
				const isSuccess = await this.option.save();
				if (isSuccess) {
					this.isShow = false;
					const data = this.option.data || {};
					const autoTable = this.autoTable;
					if (autoTable) {
						if (isInsert) {
							autoTable.insertCustomData(data);
						} else {
							autoTable.updateCustomData(data, this.option._index);
						}
					}

					const staticTable = this.staticTable;
					if(staticTable){
						const staticOption = staticTable.option || {};
						if(isInsert){
							staticOption.list.unshift(data);
						}else {
							staticOption.list.splice(this.option._index, 1, data);
						}
					}

					/*获取主要记录标识列*/
					const mainColumn = this.autoTable.$getChildComponent('link-table-column-radio');
					if(mainColumn){
						const {trueLabel,falseLabel,field} = mainColumn;
						const mainRow = mainColumn.getChecked() || {};
						const isDefault = rawData[field] === trueLabel;
						if(isDefault){
							if(mainRow.id !== data.id){
								mainColumn.setDefault(data, trueLabel);
							}
						}else if(data.id && data.id === mainRow.id){
							mainColumn.setDefault(data, falseLabel);
						}
					}
				}
			},
			/**
			 * @method：deleteRow
			 * @createdBy:黄健
			 * @date:2020/1/19
			 * @params row：数据行
			 * @params index：数据行索引
			 * @description：删除数据
			 */
			async deleteRow(row = {}, index) {
				try {
					await this.$confirm('确定删除该记录！', '提示', {type: 'warning'});
				} catch (e) {
					return;
				}
				this.option.data = row;
				const isDeleted = await this.option.doDelete();
				if (isDeleted) {
					const autoTable = this.autoTable;
					if (autoTable) {
						autoTable.deleteCustomData(index);
					}
					const staticTable = this.staticTable;
					if(staticTable){
						const staticOption = staticTable.option || {};
						staticOption.list.splice(this.option._index, 1);
					}
				}
			}
		},
		mounted() {
			this.init();
		}
	}
</script>

<style lang="scss">
	@include themeify {
		.operator-cell, .operator-button, .operate-button {
			.el-button--text {
				color: pl-var(color-primary);
				font-weight: normal;
				font-size: 12px;
				&.is-disabled{
					color: rgba(0,0,0,0.45);
				}
			}

			.split, .with-division, .icon-upright {
				display: inline-block;
				width: 1px;
				height: 12px;
				background: #e9e9e9;
				vertical-align: -2px;
			}
		}

	}

	.lnk-dlgform-panel__dialog{
		$input-width: 280px; // 输入项宽度
		$input-number-width: 88px; // 输入项宽度

		.el-dialog{
			width: 500px;
			.link-button + .link-button{
				margin-left: 8px;
			}
		}

		/* 输入框长度 */
		.el-date-editor--daterange.el-input__inner,
		.el-input,.el-textarea{
			width: $input-width;
		}

		.el-textarea__inner{
			border-radius: 0;
		}
		/*数字输入框*/
		.el-input-number{
			width: $input-number-width;
			&__decrease,&__increase{
				width: 22px;
				border-radius: 0;
			}
			.el-input{
				width: 100%;
			}
			.el-input__inner{
				padding-left: 12px;
				padding-right: 22px;
				text-align: left;
				width: $input-number-width;
			}
		}
	}
</style>
